import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import DashboardHorizontalChart from "../../../CustomComponents/DashboardHorizontalChart";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RecentlyPostedPosts from "./RecentlyPostedPosts";
import { getDashboard } from "../../../../redux/profile/action";
import DashboardChart from "../../../Common/Graphs/DashboardChart";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import RatingActiveStar from "./RatingActiveStar";
import ProfileModelProfile from "../../ManageProfile/ProfileModel/ProfileModelProfile";
import { Modal } from "reactstrap";
import { GetCountry } from "../../../../redux/master/action";
import RatingReviewsComponent from "../../../Common/RatingReviewsComponent";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { Commas, maskAccountNumber } from "../../../Common/AllDateTimeReleventFormate";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function Dashboard() {
  const path = "Assets/scss/dashboard.module.scss";
  const [modelProfile, setModelProfile] = useState(false);
  const [formData, setFormData] = useState("");
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const dashboarddata = useSelector(
    ({ profile: { dashboarddata } }) => dashboarddata,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigatetoprofile = () => {
    navigate(`/${lan}/dashboard/manageprofile`);
  };

  useEffect(() => {
    dispatch(getDashboard());
    dispatch(GetCountry());
  }, []);



  const profiledata = useSelector(({ profile: { profiledata } }) => profiledata,);
  const ratingdata = dashboarddata?.month_rating_category || [];

  useEffect(() => {
    setFormData(profiledata);
  }, [profiledata]);


  const navigatetowithdrawamount = () => {
    if (!dashboarddata?.wallet || dashboarddata?.wallet <= 0) {
      urtoast("Withdrawal amount must be greater than 0", 2);
      return;
    }
    navigate(`/${lan}/submitwithdrawamount`, {
      state: { wallet: dashboarddata?.wallet },
    });
  };

  return (
    <>
      <div className="right-sec col-md-12">
        <div className="right-first">
          <div className="dashboard-profile">
            <span>
              <div onClick={() => setModelProfile(true)}>
                <ProfileImageWithFallback url={profiledata.profile_image} />
              </div>
            </span>
            <div>
              <h2>
                Hello, {dashboarddata.first_name} {dashboarddata.last_name}
              </h2>
              {dashboarddata.role_type == "3" && <p>{decodeHtml(dashboarddata?.expert?.designation)}</p>}
              {dashboarddata.role_type == "4" && <p>{decodeHtml(dashboarddata?.industries[0]?.title)}</p>}
              <button onClick={() => navigatetoprofile()} className="btn">
                Manage profile
              </button>
            </div>
          </div>
          <button
            onClick={() => {
              navigate(`/${lan}/createpost`, { state: { theType: 1 } });
            }}
            className="btn create-post"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/plus.svg`}
              alt=""
            />
            Create a post
          </button>
        </div>
        <div className="right-second">
          <h1>Account Insights</h1>
          <div className="row dashboard-row">
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="earn-head">
                  <h2 value="1">Your Earning</h2>
                  {/* <select className =" earn-select">
                    <option value="1">Your Earning</option>
                    <option value="1">Your Earning</option>
                  </select> */}
                  {/* <select className ="form-control">
                    <option value="1">This Month</option>
                  </select> */}
                </div>
                <div className="graph-sec">
                  <h4>Total Earning</h4>
                  <h3>SAR {dashboarddata?.month_earnings || 0}</h3>
                  <h6 className="pt-2" style={{ color: '#EF7710' }}>Paid</h6>
                  <h6 style={{ color: '#EF7710' }}>SAR {dashboarddata?.month_spend || 0}</h6>
                  {/* <DashboardChart dashboarddata={dashboarddata} /> */}
                </div>
              </div>
            </div>
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="earn-head">
                  <h2>Average Rating
                    {/* {JSON.stringify(dashboarddata)} */}
                  </h2>
                </div>
                <div className="star">
                  <p>
                    <i className="fa-solid fa-star"></i>
                    <span>{profiledata?.avg_rating || 0}</span>{""}({profiledata?.comment_count}) reviews
                  </p>
                </div>
                {Array.isArray(ratingdata) && ratingdata?.map((item) => (
                  <div className="review-star">
                    <p>{item?.title} </p>
                    <RatingActiveStar value={item?.rating} />
                  </div>
                ))
                }


                {/* <div className ="review-star">
                  <p>Execution rating </p>
                  <RatingActiveStar value={4} />

                </div>
                <div className ="review-star">
                  <p>Your experience with expert </p>
                  <RatingActiveStar value={5} />
                </div> */}
              </div>
            </div>
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="earn-head">
                  <h2>All Services</h2>
                  {/* <select className ="form-control">
                    <option value="1">This Month</option>
                  </select> */}
                </div>
                <div className="project-sec">
                  <div className="project-wrapper">
                    <div className="project-img">
                      <span>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                          alt=""
                        />
                      </span>
                      <p>Total Services</p>
                    </div>
                    <h4>{dashboarddata?.total_services}</h4>
                  </div>
                  <div className="project-wrapper">
                    <div className="project-img">
                      <span>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                          alt=""
                        />
                      </span>
                      <p>Active Services</p>
                    </div>
                    <h4>{dashboarddata?.active_services}</h4>
                  </div>
                  <div className="project-wrapper">
                    <div className="project-img">
                      <span>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                          alt=""
                        />
                      </span>
                      <p>Completed Services</p>
                    </div>
                    <h4>{dashboarddata?.completed_services}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <DashboardHorizontalChart milestones={dashboarddata?.calender?.milestones} />
            </div>
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <span className="img-icon">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                    className="w-100"
                    alt=""
                  />
                </span>
                <div className="sar">
                  <h4>Available Balance</h4>
                  <p>Amount available for withdrawal</p>
                  <h1 className={dashboarddata?.wallet < 0 ? "text-danger" : ""}>
                    SAR {Commas(dashboarddata?.wallet)}
                  </h1>
                </div>
                {dashboarddata?.account_number && (
                  <div className="bank-account">
                    <p>Bank account</p>
                    <h5>{maskAccountNumber(dashboarddata?.account_number)}</h5>
                  </div>
                )}
                <button onClick={navigatetowithdrawamount} className="btn withdraw">Withdraw amount</button>
              </div>
            </div>
          </div>
        </div>
      {/* <div className="dashboard-recent-post">
        <RecentlyPostedPosts reently_posted={dashboarddata?.reently_posted} />
      </div> */}
      <div className="dashboard-rating pt-3">
        <RatingReviewsComponent formData={formData} />
      </div>
      <Modal className="popupmodal yes-no" isOpen={modelProfile}>
        <ProfileModelProfile
          edittype={1}
          formData={formData}
          setFormData={setFormData}
          setModelProfile={setModelProfile}
        />
      </Modal>
      </div>

    </>
  );
}
